import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-footer-navigation",
  templateUrl: "./footer-navigation.component.html",
  styleUrls: ["./footer-navigation.component.scss"],
})
export class FooterNavigationComponent {
  @Input() nextButtonDisabledFlag: boolean = false;
  @Input() previousButtonDisabledFlag: boolean = false;
  @Input() hostedFrom?: string = "";
  @Input() prevBtnText: string = "Previous";
  @Input() nextBtnText: string = "Next";
  @Input() nextBtnExpandFlag: boolean = false;
  @Output() prevClick = new EventEmitter<any>();
  @Output() nextClick = new EventEmitter<any>();
  @Input() totalLevelFailures?: number = 0;

  onPrevClick() {
    this.prevClick.emit();
  }

  onNextClick() {
    this.nextClick.emit();
  }
}
